(() => {
  const SECTION_SELECTOR = '.oddit-section-collection-grid';

  function initSection(section) {
    const cardsContainer = section.querySelector('.oddit-section-collection-grid__cards');
    const thumb = section.querySelector('.oddit-section-collection-grid__scrollbar-thumb');

    if (!cardsContainer || !thumb) return;

    function updateScrollbar() {
      const { scrollLeft, scrollWidth, clientWidth } = cardsContainer;
      const maxScroll = scrollWidth - clientWidth;
      if (maxScroll <= 0) {
        thumb.style.transform = 'translateX(0)';
        return;
      }
      const scrollRatio = scrollLeft / maxScroll;
      const trackWidth = thumb.parentElement.offsetWidth;
      const thumbWidth = thumb.offsetWidth;
      const maxThumbTravel = trackWidth - thumbWidth;
      thumb.style.transform = `translateX(${scrollRatio * maxThumbTravel}px)`;
    }

    cardsContainer.addEventListener('scroll', updateScrollbar, { passive: true });

    // Initial update
    updateScrollbar();
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();